var $ = require('jquery');

export default {
  init: function () {
    function a() {
      $(".toggler.active").each(function () {
        var a = $(this),
          b = $(a.data("toggleTarget")),
          c = $(a.data("toggleOnActiveMatchHeight")),
          d = $(a.data("toggleOnActiveMatchHeightSrc"));
        c.length > 0 && c.imagesLoaded(function () {
          var a = b.outerHeight();
          d.length > 0 && (a = d.outerHeight()), c.css({
            height: a
          }), setTimeout(function () {
            c.css({
              height: a
            })
          }, 750)
        })
      });
      
      $("[data-toggle-on-active-match-height].active:not(.toggler)").each(function () {
        var a = $(this),
          b = $(a.data("toggleOnActiveMatchHeight"));
        b.length > 0 && a.imagesLoaded(function () {
          setTimeout(function () {
            b.css({
              height: a.outerHeight()
            })
          }, 750)
        })
      })
    }
    
    $.fn.togglerize = function (a) {
      $(this).each(function (a) {
        var b = $(this),
          c = $(b.data("toggleFocus")),
          d = b.data("toggleClass"),
          e = b.data("toggleGroup"),
          f = b.data("toggleBodyFixedHeight"),
          g = $(b.data("toggleOnActiveMatchHeight")),
          h = $(b.data("toggleOnActiveMatchHeightSrc")),
          i = b.data("toggleSelfOffDisabled"),
          j = b.data("toggleOffClick");
        b.data("togglerized", !0);
        var k = {};
        $.extend(k, a), d && "" != d || (d = "active");
        var l
        var m = function () {
            var a = $(b.data("toggleTarget"));
            "self" == b.data("toggleTarget") && (a = b), "self" != b.data("toggleTarget") && $('[data-toggle-target="' + b.data("toggleTarget") + '"]').removeClass(d), a.removeClass(d), f && $("body").removeClass("fixed-height"), b.removeClass(d), clearTimeout(l), a.each(function () {
              $(this).triggerHandler("toggled:off")
            })
          }
        var n = function () {
          var a = $(b.data("toggleTarget"));
          "self" == b.data("toggleTarget") && (a = b), e && "" != e && $('[data-toggle-group="' + e + '"]').removeClass(d).each(function () {
            $(this).triggerHandler("toggled:off")
          }), c.focus(), c.select(), b.data("toggleSelfDelay") ? l = setTimeout(function () {
            b.addClass(d), a.addClass(d), k.toggledHandler && k.toggledHandler()
          }, b.data("toggleSelfDelay")) : setTimeout(function () {
            b.addClass(d), a.addClass(d), k.toggledHandler && k.toggledHandler()
          }), f && $("body").addClass("fixed-height"), g.length > 0 && g.imagesLoaded(function () {
            var b = a.outerHeight();
            h.length > 0 && (b = h.outerHeight()), g.css({
              height: b
            })
          }), a.each(function () {
            var a = $(this),
              b = $(a.data("toggleOnActiveMatchHeight"));
            b.length > 0 && a.imagesLoaded(function () {
              b.css({
                height: a.outerHeight()
              })
            }), a.triggerHandler("toggled:on")
          })
        }
        var o = function (a) {
          var c = $(b.data("toggleTarget"));
          "self" == b.data("toggleTarget") && (c = b) 
          c.hasClass(d) && !i ? m() : n() 
          b.data("toggleDisablePropagation") && a.stopPropagation()
        };
        if (b.data("hoverToggle")) {
          var p = function () {
            b.mouseover(function () {
              $("body").hasClass("touched") || n()
            }), b.mouseout(function () {
              $("body").hasClass("touched") || i || m()
            }), $(document).off("mousemove", p)
          };
          $(document).on("mousemove", p), b.click(function (a) {
            $("body").hasClass("touched") && o(a)
          })
        } else 
        {
          // Remove other click 
          b.unbind("click")
          b.click(function (a) {
            o(a)
          });
        }
        j && $(document).on("click", function (a) {
          $.contains(b.get(0), a.target) || a.target === b.get(0) || $(a.target).is(b.data("toggleTarget")) || $(a.target).closest(b.data("toggleTarget")).length <= 0 && m()
        })
      })
    }
    
    $(".toggler").each(function () {
      $(this).togglerize()
    });
    
    $(window).resize(a), a(), $(".disable-propagation").click(function (a) {
      a.stopPropagation()
    })
  }
}